import {ChipList} from '@ui/forms/input-field/chip-field/chip-list';
import {Chip} from '@ui/forms/input-field/chip-field/chip';
import {Trans} from '@ui/i18n/trans';
import React from 'react';
import {useLinkFiltersData} from '@app/liens/use-link-filters';

export function EnumLinkQualityByIdChip({quality}: {quality: number}) {
  const data = useLinkFiltersData();
  const qualityData = data.qualities.find(q => q.id === quality);
  return (
    <ChipList radius="rounded" size="xs">
      <Chip key={quality} selectable>
        {qualityData?.name && <Trans message={qualityData?.name} />}
      </Chip>
    </ChipList>
  );
}
